/// <reference types="vite-plugin-pwa/react" />
import { useRegisterSW } from 'virtual:pwa-register/react';

/** Service-worker update prompt (business build). A new version is only
 * activated when the receptionist chooses to — never silently mid-scan. The
 * desk queue is persisted, so reloading loses nothing. */
export function UpdateBar() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-40 flex flex-wrap items-center justify-center gap-md border-t border-sky bg-tint-sky px-lg py-sm text-body text-ink"
    >
      <span>A new version of NamibiaGo Business is ready.</span>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className="rounded-button bg-canyon px-md py-xs font-semibold text-white"
      >
        Reload
      </button>
      <button type="button" onClick={() => setNeedRefresh(false)} className="text-ink-2 underline">
        Later
      </button>
    </div>
  );
}
